import { defineMessages } from 'react-intl';

type MessageKeys = 'chatToAgentButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		chatToAgentButton: {
			id: 'rovo-chat.view-agent.chat-to-agent-button',
			defaultMessage: 'Chat to agent',
			description:
				'Button label in the agent details view. When clicked, opens a chat conversation with the selected agent.',
		},
	});

export default message;
